import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { colors } from '../../constants/colors'
import analyticsimg from '../../assets/images/analytics.png'
import casesimg from '../../assets/images/Cases.png'
import mage_dashboard from '../../assets/images/mage_dashboard.png'
import arcticons_brainfm from '../../assets/images/arcticons_brainfm.png'
import streamline_design_file_ai_bold from '../../assets/images/streamline-ultimate_design-file-ai-bold.png'
import fluent_mdl2_visuals_folder from '../../assets/images/fluent-mdl2_visuals-folder.png'
import material_symbols_bug_report_outline_rounded from '../../assets/images/material-symbols_bug-report-outline-rounded.png'
import material_symbols_library_books_outline_rounded from '../../assets/images/material-symbols_library-books-outline-rounded.png'
import chattext from '../../assets/images/ChatText.png'
import fluent_people_team_20_regular from '../../assets/images/fluent_people-team-20-regular.png'
import teamimg from '../../assets/images/team.png'
import stash_billing_info_light from '../../assets/images/stash_billing-info-light.png'
import logo from '../../assets/images/Trigger.png'


const Sidebar = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const user = useSelector((s) => s.auth.user)
  const isOwner = user?.role === 'Owner'

  const sidebarStyle = {
    width: '280px',
    height: '100vh',
    backgroundColor: colors.background.primary,
    borderRight: `1px solid ${colors.borderVariants.light}`,
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: 1000
  }

  const headerStyle = {
    padding: '24px 20px',
    borderBottom: `1px solid ${colors.borderVariants.light}`,
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  }

  const logoStyle = {
    width: '40px',
    height: '40px',
   
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  }

  const logoIconStyle = {
    width: '50px',
    height: '50px',
    color: 'white'
  }

  const brandTextStyle = {
    display: 'flex',
    flexDirection: 'column'
  }

  const brandNameStyle = {
    fontSize: '18px',
    fontWeight: '700',
    color: colors.text.primary,
    margin: 0,
    lineHeight: '1.2'
  }

  const brandSubtitleStyle = {
    fontSize: '14px',
    color: colors.text.secondary,
    margin: 0,
    lineHeight: '1.2'
  }

  const navStyle = {
    flex: 1,
    padding: '30px 0',
    paddingBottom: '40px',
    overflowY: 'auto'
  }

  const navItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    padding: '12px 25px',
    paddingTop: '25px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: 'none',
    backgroundColor: 'transparent',
    width: '100%',
    textAlign: 'left'
  }

  const activeNavItemStyle = {
    ...navItemStyle,
    backgroundColor: colors.primary,
    color: 'white',
    borderRadius: '8px',
    marginBottom: '10px',
    marginTop: '10px'
  }

  const inactiveNavItemStyle = {
    ...navItemStyle,
    color: colors.text.primary,
    ':hover': {
      backgroundColor: colors.background.secondary
    }
  }

  const iconStyle = {
    width: '20px',
    height: '20px',
    flexShrink: 0,
    objectFit: 'contain',
    display: 'block'
  }

  const textStyle = {
    fontSize: '15px',
    fontWeight: '600',
    margin: 0
  }

  const SettingsGearIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      style={{ ...iconStyle, color: 'inherit' }}
    >
      <circle cx="12" cy="12" r="3" />
      <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" strokeLinecap="round" />
    </svg>
  )

  const navigationItems = [
    { id: 'dashboard', label: 'Dashboard', icon: 'grid', path: '/dashboard' },
    { id: 'analytics', label: 'Analytics Overview', icon: 'chart', path: '/analytics' },
    { id: 'web-analytics', label: 'Web Analytics', icon: 'chart', path: '/web-analytics' },
    // { id: 'project-builder', label: 'Project Builder', icon: 'folder', path: '/project-builder' },
    { id: 'intent-management', label: 'Intent Management', icon: 'target', path: '/intent-management' },
    { id: 'ai-training', label: 'AI Training Data', icon: 'document', path: '/ai-training' },
    { id: 'visual-guides', label: 'Visual Guide Manager', icon: 'chart-folder', path: '/visual-guides' },
    { id: 'bug-reports', label: 'Bug Report', icon: 'bug', path: '/bug-reports' },
    { id: 'media-library', label: 'Media Library', icon: 'image', path: '/media-library' },
    { id: 'chat-logs', label: 'Chat Logs', icon: 'chat', path: '/chat-logs' },
    { id: 'team-management', label: 'Team Management', icon: 'teammanagement', path: '/teammanagement' },
    { id: 'billing', label: 'Subscription/Billing', icon: 'dollar', path: '/billing' },
    ...(isOwner ? [{ id: 'settings', label: 'Settings', icon: 'settings', path: '/settings' }] : [])
  ]

  const getIcon = (iconName) => {
    const iconMap = {
      grid: mage_dashboard,
      chart: analyticsimg,
      folder: casesimg,
      target: arcticons_brainfm,
      document: streamline_design_file_ai_bold,
      'chart-folder': fluent_mdl2_visuals_folder,
      bug: material_symbols_bug_report_outline_rounded,
      image: material_symbols_library_books_outline_rounded,
      chat: chattext,
      teammanagement: teamimg,
      users: '/fluent_people-team-20-regular.png',
      dollar: stash_billing_info_light,
    }
    
    const iconPath = iconMap[iconName]
    console.log(`Loading icon: ${iconName} -> ${iconPath}`)
    
    if (iconPath) {
      return (
        <img 
          src={iconPath} 
          alt={iconName} 
          style={iconStyle}
          onLoad={() => console.log(`Successfully loaded: ${iconPath}`)}
          onError={(e) => {
            console.error(`Failed to load icon: ${iconPath}`)
            e.target.style.display = 'none'
          }}
        />
      )
    }
    return null
  }

  const handleNavigation = (path) => {
    navigate(path)
  }

  return (
    <div style={sidebarStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <div style={logoStyle}>
          <img 
            src={logo} 
            alt="KBI Logo" 
            style={logoIconStyle}
          />
        </div>
        <div style={brandTextStyle}>
          <h1 style={brandNameStyle}>KBI</h1>
          <p style={brandSubtitleStyle}>ProgressArc</p>
        </div>
      </div>

      {/* Navigation */}
      <nav style={navStyle}>
        {navigationItems.map((item) => {
          const isActive = location.pathname === item.path
          const itemStyle = isActive ? activeNavItemStyle : inactiveNavItemStyle
            
          return (
            <button
              key={item.id}
              style={itemStyle}
              onClick={() => handleNavigation(item.path)}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.target.style.backgroundColor = colors.background.secondary
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.target.style.backgroundColor = 'transparent'
                }
              }}
            >
              {item.icon === 'settings' ? <SettingsGearIcon /> : getIcon(item.icon)}
              <span style={textStyle}>{item.label}</span>
            </button>
          )
        })}
      </nav>
    </div>
  )
}

export default Sidebar
